import {
  showToast,
  uuidV4,
  wrappedPost,
  yesNoConfirm,
} from "@sourcewhale/shared/src/assets/js/src/general/utils.js";
import { tagsStore } from "../../../../svelte/api-stores/tags-store";

export const TAGS = [];

let initialized = false;

const initialize = () => {
  if (initialized) return;
  tagsStore.subscribe(($tagsStore) => {
    TAGS.splice(0, TAGS.length); // empty array
    $tagsStore
      .sort((a, b) => (a.title > b.title ? 1 : -1))
      .forEach((x) => {
        TAGS.push(x);
      });
  });
  initialized = true;
};

export const refreshTags = async ({
  assignTag = false,
  isTemplate = false,
}) => {
  initialize();
  $(".tagTitleInput").val("");
  const lastTags = JSON.parse(JSON.stringify(TAGS));
  let res = await tagsStore.get();
  if (!res) return; // 401 - will imminently redirect to login

  const newTagsArr = assignTag
    ? res.filter((o1) => !lastTags.some((o2) => o1.tagId === o2.tagId))
    : [];

  $("#tagsDiv").empty();

  if (isTemplate) {
    $("#templateTagSelector option").remove();
  } else {
    $("#manualCandidateTagSelector option").remove();
  }

  TAGS.forEach((item) => {
    const id = uuidV4();

    $("#tagsDiv").append(/* html */ `
            <span class="mr-2 px-2 py-1 badge badge-primary d-inline-flex tag-title">
              <span class='hidden-input' data-tag-id="${item.tagId}" contenteditable>${item.title}</span>
              <i id="${id}" class="fas fa-times ml-2"></i>
            </span>`);

    $(`#${id}`).click(() => {
      yesNoConfirm(
        `Are you sure you would like to delete "${item.title}"?`,
        () => {
          wrappedPost({
            url: "/api/tags/modify",
            data: JSON.stringify({ kind: "delete", tagId: item.tagId }),
            success: () => {
              refreshTags({ assignTag, isTemplate });
            },
          });
        },
      );
    });

    if (isTemplate) {
      $("#templateTagSelector").append(
        $("<option>", { value: item.tagId, text: item.title }),
      );
    } else {
      $("#manualCandidateTagSelector").append(
        $("<option>", { value: item.tagId, text: item.title }),
      );
    }
  });

  if (isTemplate) {
    $("#templateTagSelector").selectpicker("refresh");
  } else {
    $("#manualCandidateTagSelector").selectpicker("refresh");
  }

  const selector = $(".tagSelectpicker");
  selector.empty();

  res = res.sort((a, b) => (a.title > b.title ? 1 : -1));

  res.forEach((tag) => {
    selector.append(
      $("<option>", {
        value: tag.tagId,
        "data-content": `<i class="fa-regular fa-tag fa-sm mr-2"></i>${tag.title}`,
      }),
    );
  });

  if (newTagsArr.length) {
    const assignTagsSelector = $("#assignTagsSelector");
    if (assignTagsSelector.length === 0) return;
    assignTagsSelector.selectpicker("val", newTagsArr[0].tagId);
  }

  selector.selectpicker("refresh");
};

const createTag = ({ e, isTemplate = false }) => {
  const tagTitleInput = $(e.currentTarget)
    .parent()
    .parent()
    .find(".tagTitleInput")
    .val();
  if (tagTitleInput === "") return;

  $(".tagAddBtn i")
    .removeClass("fa-plus")
    .addClass("fast-spin fa-circle-notch");

  wrappedPost({
    url: "/api/tags/modify",
    data: JSON.stringify({ kind: "create", title: tagTitleInput }),
    success: () => {
      $("#tagsModal .clearTextCloseBtn").hide();
      $(".tagAddBtn i")
        .addClass("fa-plus")
        .removeClass("fast-spin fa-circle-notch");
      $(".tagTitleInput").val("");

      refreshTags({ assignTag: true, isTemplate });
    },
    error: () => {
      $(".tagAddBtn i")
        .addClass("fa-plus")
        .removeClass("fast-spin fa-circle-notch");
    },
  });
};

export const registerTagEventHandlers = ({
  applyToIds, // a function that takes a callback that will be called with the selected ids
  isTemplate = false,
}) => {
  $("#tagsModal").on("focusout", ".tag-title .hidden-input", (e) => {
    const tagId = e.currentTarget.getAttribute("data-tag-id");
    const title = e.currentTarget.innerText;
    wrappedPost({
      url: "/api/tags/modify",
      data: JSON.stringify({ kind: "modify", tagId, title }),
      success: () => refreshTags({ isTemplate }),
    });
  });

  const addTagBtnHandler = (action, buttonId) => {
    $(buttonId).on("click", () => {
      applyToIds((ids) => {
        const tagIds = $("#assignTagsSelector").selectpicker("val");

        const data = {
          kind: isTemplate ? "template" : "candidate",
          [action]: Object.fromEntries(tagIds.map((tagId) => [tagId, ids])),
        };
        wrappedPost({
          url: "/api/tags/associate",
          data: JSON.stringify(data),
          success: () => {
            $("#assignTagsModal").modal("hide");

            const s = ids.length === 1 ? "" : "s";
            const entity = isTemplate ? "template" : "contact";

            const successMessage =
              action === "add"
                ? `Successfully assigned tags to ${ids.length} ${entity}${s}`
                : `Successfully removed tags from ${ids.length} ${entity}${s}`;

            showToast({ title: successMessage, type: "success" });
          },
          spinner: buttonId,
        });
      });
    });
  };

  addTagBtnHandler("add", "#assignTagsButton");
  addTagBtnHandler("remove", "#removeTagsBtn");

  $(".tags-button").on("click", () => {
    $("#tagsModal").modal("show");
    refreshTags({ isTemplate });
  });

  $(".tagTitleInput").on("keydown", (e) => {
    if (e.key === "Enter") createTag({ e, isTemplate });
  });

  $(".tagAddBtn").on("click", (e) => {
    createTag({ e, isTemplate });
  });

  const toggleButtons = (selectedTagIds) => {
    const isDisabled = selectedTagIds.length === 0;
    $("#assignTagsButton, #removeTagsBtn").prop("disabled", isDisabled);
  };

  $(".assign-tags-button").click(() => {
    toggleButtons($("#assignTagsSelector").selectpicker("val"));
    $("#assignTagsModal").modal("show");
  });

  $("#assignTagsSelector").on("changed.bs.select", (e) =>
    toggleButtons($(e.currentTarget).val()),
  );
};
